import { AppNoInfo } from '@/layout/AppComponents';
import SpinnerLoader from '../../../components/helpers/SpinnerLoader';
import CommunicationPipelineHomeAdmin from './Admin/CommunicationPipelineHomeAdmin';
import CommunicationPipelineHomeUser from './User/CommunicationPipelineHomeUser';

export default function CommunicationPipelinePermissionsSwitch(props) {
  const { permissionLevel } = props;

  switch (permissionLevel) {
    case 1:
      return <CommunicationPipelineHomeUser />;
    case 0:
      return <CommunicationPipelineHomeAdmin />;
    default:
      return (
        <AppNoInfo>
          <SpinnerLoader />
        </AppNoInfo>
      );
  }
}
